/**
 * 获取paint数据 fp fcp
 * @returns Promise<{ fp?: number, fcp?: number }>
 */
export default function getPaintInfo(): Promise<{ fp?: number, fcp?: number }> {
  const paintObj: any = {};
  return new Promise((resolve) => {
    let n = 0;
    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        switch (entry.name) {
        case 'first-paint':
          paintObj.fp = Math.round(entry.startTime);
          n += 1;
          break;
        case 'first-contentful-paint':
          paintObj.fcp = Math.round(entry.startTime);
          n += 1;
          break;
        default:
          break;
        }
      }
      if (n === 2) {
        resolve(paintObj);
      }
    });
    po.observe({type: 'paint', buffered: true});
  }).catch(() => paintObj);
}
